import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import getTags from './tags';

import { SEO } from '@config';
const { appendix } = SEO;

const MetaTags = ({ page, title, description, image, url, robots, additionalTags = [], routeId, city, address }) => {
  const tags = getTags({ page, title, description, robots, city, address }) || {};

  return (
    <>
      {routeId && (
        <Helmet>
          <body id={routeId}/>
        </Helmet>
      )}

      {tags.title && (
        <Helmet>
          <title>{tags.title} {appendix}</title>
          <meta name="title" content={tags.title}/>
          <meta property="og:title" content={tags.title}/>
          <meta name="twitter:title" content={tags.title}/>
        </Helmet>
      )}

      {tags.description && (
        <Helmet>
          <meta name="description" content={tags.description}/>
          <meta property="og:description" content={tags.description}/>
          <meta name="twitter:description" content={tags.description}/>
        </Helmet>
      )}

      {url && (
        <Helmet>
          <meta property="og:url" content={url}/>
          <meta name="twitter:url" content={url}/>
        </Helmet>
      )}

      {image && (
        <Helmet>
          <meta property="og:image" content={image}/>
          <meta name="twitter:image" content={image}/>
        </Helmet>
      )}

      {tags.robots && (
        <Helmet>
          <meta name="robots" content={tags.robots} />
        </Helmet>
      )}

      {additionalTags.map((tag, index) => (
        <Helmet key={index}>
          <meta name={tag.name} property={tag.property} content={tag.content} />
        </Helmet>
      ))}
    </>
  );
};

MetaTags.propTypes = {
  routeId: PropTypes.string,
  page: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  url: PropTypes.string,
  additionalTags: PropTypes.array,
  robots: PropTypes.string,
  city: PropTypes.string,
  address: PropTypes.string,
};

export default MetaTags;
